import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import './fonts/DanaFaNum-Regular.ttf';
import './fonts/DanaFaNum-Regular.woff';
import './fonts/DanaFaNum-Regular.woff2';
import './fonts/DanaFaNum-Bold.ttf';
import './fonts/DanaFaNum-Bold.woff';
import './fonts/DanaFaNum-Bold.woff2';
import { BrowserRouter } from 'react-router-dom';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>

      <App />

    </BrowserRouter>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
